import { render, staticRenderFns } from "./historyDetail.vue?vue&type=template&id=91dcad3a&scoped=true&"
import script from "./historyDetail.vue?vue&type=script&lang=js&"
export * from "./historyDetail.vue?vue&type=script&lang=js&"
import style0 from "./historyDetail.vue?vue&type=style&index=0&id=91dcad3a&prod&scoped=true&lang=css&"
import style1 from "./historyDetail.vue?vue&type=style&index=1&id=91dcad3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dcad3a",
  null
  
)

export default component.exports